import * as angular from "angular";
import {IController, ILogService} from "angular";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {AgentInventoryDialogService} from "../../angular/services/agent-inventory-dialog.service";
import {AgentInventoryService} from "../../services/agent-inventory-service.service";
import * as _ from "lodash";
import {AgentInventoryActionType} from "../../types/agent-inventory-action.type";

export class InventoryTransactionsCtrl implements IController {

  public filtersConfig;
  public infiniteScroll: any;
  public actionType: typeof AgentInventoryActionType = AgentInventoryActionType;
  public isLoadSelected: boolean = true;
  public isUnloadSelected: boolean = true;

  private transactionsRef: any;
  private loadLimit: number = 30;

  constructor(
    private $agentInventory,
    private $infiniteScroll,
    private $log: ILogService,
    private agentInventoryDialogService: AgentInventoryDialogService,
    private agentInventoryService: AgentInventoryService
  ) {
  }

  $onInit() {
    // Initialize filters configuration
    this.filtersConfig = {
      includeFilters: [
        SiteFiltersType.branchIds,
        SiteFiltersType.depotIds,
        SiteFiltersType.accountIds,
        SiteFiltersType.agentIds
      ],
      bringozFilters: {
        [SiteFiltersType.branchIds]: [],
        [SiteFiltersType.depotIds]: [],
        [SiteFiltersType.accountIds]: [],
        [SiteFiltersType.agentIds]: []
      }
    };

    this.transactionsRef = this.$agentInventory();
    this.transactionsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.transactionsRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes: angular.IOnChangesObject) {

  }

  onActionTypeSelect(actionType: AgentInventoryActionType) {
    if (actionType === AgentInventoryActionType.Load) {
      this.isLoadSelected = !this.isLoadSelected;
    }
    if (actionType === AgentInventoryActionType.Unload) {
      this.isUnloadSelected = !this.isUnloadSelected;
    }
    this._reload();
  }

  onFiltersChange(filters) {
    this.filtersConfig.bringozFilters = filters;
    this._reload();
  }

  openCreateDialog(event) {
    const locationType = undefined;
    const locationId = undefined;
    const locationData = undefined;

    this.agentInventoryDialogService.createTransaction(event, locationType, locationId, locationData)
      .then((transactionPayload) => {
        if (transactionPayload) {
          // Determine which method to call based on action type
          const apiCall = transactionPayload.actionType === 'Unload'
            ? this.agentInventoryService.createUnloadTransaction(transactionPayload)
            : this.agentInventoryService.createLoadTransaction(transactionPayload);

          apiCall
            .then(() => {
              this._reload();
            })
        }
      })
      .catch(() => {
        // Dialog was cancelled
      });
  }

  private _reload() {
    this.transactionsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      });
  }

  private _getQueryPayload() {
    const actionTypes = [];
    if (this.isLoadSelected) {
      actionTypes.push(AgentInventoryActionType.Load);
    }
    if (this.isUnloadSelected) {
      actionTypes.push(AgentInventoryActionType.Unload);
    }
    return {
      limit: this.loadLimit,
      actionTypes: actionTypes?.length ? actionTypes : undefined,
      locationIds: _.concat(this.filtersConfig.bringozFilters.accountIds, this.filtersConfig.bringozFilters.depotIds),
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      sort: 'createdAt,desc'
    };
  }

}

angular
  .module('bringoz.admin.agent-inventory')
  .component('inventoryTransactions', {
    bindings: {},
    template: require('./inventory-transactions.html').default,
    controller: InventoryTransactionsCtrl
  });
